import React from 'react';
import styled from 'styled-components';
import IconLoading from '../atoms/IconLoading';

const Holder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  @media(${props => props.theme.breakpoints.md}) {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Inner = styled.div`  
  background-color: ${props => props.theme.colours.white};
  box-shadow: ${props => props.theme.boxShadow};
  width: 100%;
  height: 100%;
  overflow: hidden;
  max-width: 100%;
  position: relative;
  @media(${props => props.theme.breakpoints.md}) {
    border-radius: 2rem;
    width: 40rem;
    height: 80rem;
    max-height: 90vh;
  }
`;

const IconHolder = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

function ChatHolder( props ) {
  return (
    <Holder>
      <Inner id="chat-holder">
        <IconHolder>
          <IconLoading/>
        </IconHolder>
      </Inner>
    </Holder>
  )
}

export default ChatHolder;
